import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4caa04c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-upcom__date" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-upcom__img" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-upcom__wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-upcom__desc" }),
  /*#__PURE__*/_createElementVNode("div", { class: "card-upcom__text" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-upcom__applicants" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-upcom__applicants--spread" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardWrap = _resolveComponent("CardWrap")!

  return (_openBlock(), _createBlock(_component_CardWrap, { class: "card-upcom--padding-fix card-upcom--order" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _: 1
  }))
}